<script lang="ts" setup>
definePageMeta({ layout: false });

const onRefresh = () => {
  window.location.reload();
};
</script>

<template>
  <div class="w-dvw h-dvh">
    <div class="h-full w-full flex flex-col items-center justify-center text-gray-900">
      <span class="text-3xl font-bold leading-10">
        Website in maintenance
      </span>

      <h1 class="text-xl font-bold leading-8">
        Await some time and try refresh page
      </h1>

      <div class="flex justify-center gap-2 py-4">
        <UButton
          size="xl"
          icon="ic:round-refresh"
          label="Refresh"
          @click="onRefresh"
        />
      </div>
    </div>
  </div>
</template>
